<template>
  <header class="navcontainer">
    <b-navbar toggleable="lg" class="navbar navbar-dark container">
      <b-navbar-brand to="/">
        <img
          src="../assets/Platform-Varsom.svg"
          width="40"
          height="40"
          alt="Abonner.varsom.no - logo"
        />
        <label>Varsom abonner</label>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" v-if="!mainFault"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav v-if="!mainFault" role="menubar">
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            v-if="userLoggedIn"
            to="/Varsler"
            :class="{ active: isSubActive }"
          >
            <div class="mark" :class="{ active: isSubActive }" />
            <span>VARSLER</span>
          </b-nav-item>
          <b-nav-item-dropdown
            text="OM TJENESTEN"
            :class="{ active: isAboutDropdownActive }"
            ref="userDropdown"
            triggers="focus"
          >
            <template slot="button-content">
              <div class="mark" :class="{ active: isAboutDropdownActive }" />
              <span>OM TJENESTEN</span>
            </template>
            <b-dropdown-item to="/Tjenesten" :class="{ active: isAboutActive }"
              >Om tjenesten</b-dropdown-item
            >
            <b-dropdown-item
              to="/Personvern"
              :class="{ active: isPrivacyActive }"
              >Data og personvern</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <b-nav-item v-if="userLoggedIn" @click="profile">
            <span>NVE Konto</span>
          </b-nav-item>
          <b-nav-item v-if="!userLoggedIn" to="/Varsler">
            <div class="mark" />
            <span>LOGG INN</span>
          </b-nav-item>
          <b-nav-item v-if="userLoggedIn" @click="logout">
            <span>LOGG UT</span>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
import routeNames from "../router/routeNames";

export default {
  name: "Header",
  computed: {
    mainFault() {
      return window.grandFail == true;
    },
    user() {
      return this.$store.getters.user;
    },
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
    isAboutDropdownActive() {
      return (
        this.$route.name === routeNames.OmTjenesten ||
        this.$route.name === routeNames.Personvern
      );
    },
    isAboutActive() {
      return this.$route.name === routeNames.OmTjenesten;
    },
    isPrivacyActive() {
      return this.$route.name === routeNames.Personvern;
    },
    isWelcomeActive() {
      return this.$route.name === routeNames.Welcome;
    },
    isSubActive() {
      return this.$route.name === routeNames.Varsler;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    },
    profile() {
      location.href = this.$store.getters.userProfileUri;
    }
  },
};
</script>

<style lang="scss">
div.mark {
  height: 20px;
  width: 8px;

  background: inherit;
  float: left;
  position: relative;
  top: 2px;
  left: -12px;

  margin: 0;
  padding: 0;

  &.active {
    background: #ee7b04;
  }
}

div.mark2 {
  height: 20px;
  width: 8px;
  background: inherit;
  position: relative;
  top: 28px;
  left: 28px;

  &.active {
    background: #ee7b04;
  }
}

#nav-collapse-no.user,
#nav-collapse {
  background-color: #044962;
  z-index: 20;
}
ul.dropdown-menu {
  &:not(.show) {
    z-index: 0;
    display: none;
    visibility: hidden;
  }
}

.navcontainer {
  background-color: #044962;
  color: white;
  padding: 0;
  margin: 0;
  line-height: 140%;
  height: 70px;

  nav {
    margin-top: 0;
    margin-bottom: 0;
    padding: 0;
    line-height: 140%;
    height: 70px;
  }

  .navbar-brand {
    padding: 0;
    height: 70px;
    line-height: 70px;
  }
  a.navbar-brand > label {
    cursor: pointer !important;
    padding: 0;
    margin: 0;
    margin-left: 18px;
    font-size: 20px;
  }

  .navbar-brand:focus {
    opacity: 1;
    outline: inherit;
  }

  .nav-item a.nav-link {
    border-left: inherit;
    border-bottom: inherit;
    text-decoration: none;
    text-transform: uppercase;
    color: #fff;
  }
  .nav-item a.active {
    border-bottom: inherit;
    opacity: inherit;
    outline: inherit;
    text-decoration: inherit;
  }
  .nav-item a.active:focus {
    border-bottom: inherit;
    opacity: inherit;
    outline: inherit;
    text-decoration: inherit;
  }
  .nav-item a:focus {
    border-left: inherit;
    border-bottom: inherit;
    opacity: inherit;
    outline: inherit;
    text-decoration: inherit;
  }

  li.nav-item {
    height: 70px;
    line-height: 70px;
    padding-top: 18px;
    white-space: nowrap;
    padding-right: 40px;
    padding-left: 32px;
    span {
      color: white;
    }

    &:hover {
      border: none;
      background-color: #ffcc33;
      color: #222 !important;
    }
  }

  .dropdown-item {
    color: black;
    height: 70px;
    line-height: 70px;
    border: inherit;
  }

  .dropdown-item.active,
  .dropdown-item:active {
    background-color: #e6edef;
    color: black;
    border: none !important;
  }

  .dropdown-menu {
    margin: 0 0 0 14px;
    padding: 0;

    color: black;
    font-size: 16px;

    height: 140px;
    width: 272px;

    border: none;
    border-radius: 0;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

    // Slide down transtion
    display: block !important;

    &:not(.show) {
      padding: 0px;
      border-width: 0px;
      border-color: transparent;
      box-shadow: none;
      border: none;
      background: transparent;

      transition: padding 1.3s, border-width 1.3s ease, z-index 2s,
        border-color 0.3s, box-shadow 0.3s ease;
    }

    > li {
      max-height: 0px;
      overflow: hidden;
      transition: max-height 0.3s ease;
    }

    &.show {
      > li {
        max-height: 100px;
      }
    }
  }
}

.dropdown-toggle::after {
  margin-top: -20px;
  position: relative;
  top: 4px;
  height: 10px;
  width: 19px;
  padding: 0;
  padding-left: 22px;
  border: none !important;
  content: url("../assets/icons/chevron-down.svg") !important;
}

ul.dropdown-menu {
  &.show {
    z-index: inherit;
  }
  &:not(.show) {
    z-index: 10000;
  }
}

.show > .dropdown-toggle::after {
  margin-top: -20px;
  position: relative;
  top: 4px;
  height: 10px;
  width: 19px;
  padding: 0;
  padding-left: 22px;
  border: none !important;
  content: url("../assets/icons/chevron-up.svg") !important;
}
</style>
